import { browser } from '$app/environment';

export class Mutex {
    /**
     * If called in a *browser* context it will run the callback inside a https://developer.mozilla.org/en-US/docs/Web/API/Lock lock,
     * otherwise it will just invoke the callback and return the result without any locking.
     */
    static runExclusive<T>(name: string, callback: () => Promise<T>): Promise<T> {
        if (!browser) {
            return callback();
        }
        return navigator.locks.request(name, async () => await callback());
    }
    static snapshot = () => (!browser ? undefined : navigator.locks.query());
}
